import { initializeFacilitator } from './Facilitator';
import { initializeHeartbeat } from './Heartbeat';
import { initializeImageCache } from './ImageCache';
import { initializeLogger } from './Log';
import { initializeNetwork } from './Network';
import { initializeQueryManager } from './QueryManager';
import { initializeScreenshot } from './Screenshot';
import { initializeWeatherAlerts } from './WeatherAlerts';

function initializeAuxillaryServices(): void {
    initializeQueryManager();
    initializeImageCache();
    initializeScreenshot();
    initializeLogger();
    initializeFacilitator();
    initializeNetwork();
    initializeHeartbeat();
    initializeWeatherAlerts();
}

export * from './AuxillaryServices';
export { initializeAuxillaryServices };
